module.exports = __webpack_public_path__ + "img/pv_year_gen.ab3f74f9.svg";